import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const BannerImage2 = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex relative flex-col gap-4 bg-[#F2F2F2] h-full w-full border border-gray-50">
        <img src={data.fileUrl ?? "/blank-image-placeholder.png"} alt={data.title ?? "Hero Section"} className="w-full object-cover h-full object-center " />
      </div>
    </EditableSection>
  )
}

export default BannerImage2